import { render, staticRenderFns } from "./CustomContent.vue?vue&type=template&id=40aab8da"
import script from "./CustomContent.vue?vue&type=script&lang=js"
export * from "./CustomContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports